import React, { FunctionComponent } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import { TooltipComponentProps } from './TooltipComponent.types';
import './TooltipComponent.scss';

const useStyles = makeStyles({
  customTooltip: {
    fontSize: '13px',
  },
});

export const TooltipComponent: FunctionComponent<
  TooltipComponentProps
> = props => {
  const {
    arrow = false,
    children,
    className,
    id,
    placement = 'top',
    title,
    skidding = 0,
    offset = 0,
  } = props;
  const classes = useStyles();

  return (
    <Tooltip
      arrow={arrow}
      id={id}
      className={className}
      classes={{ tooltip: classes.customTooltip }}
      placement={placement}
      title={title}
      PopperProps={{
        popperOptions: {
          modifiers: {
            offset: {
              enabled: true,
              offset: `${skidding}px, ${offset}px`,
            },
          },
        },
      }}
    >
      <span>{children}</span>
    </Tooltip>
  );
};
